export default function LeagueSquaresRoute() {
  return null;
}
